import { openInNewTab } from "@helpers"

export default function useSalonFileController(salonId: string | number): Customer.Controllers.SalonFiles {
    const endpoint = `/api/customer/salons/${salonId}/files`

    const report = `${endpoint}/report`

    return { report }
}